import React from 'react';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';

const getDevice = (selectedResolution: any) => {
	if (selectedResolution < 640) return { device: 'phone', isMobile: true };
	if (selectedResolution <= 1024) return { device: 'tablet', isMobile: true };
	return { device: 'desktop', isMobile: false };
};

const useDevice = () => {
	const selectedResolution = useSelector(selectedToggleValue);
	const [device, setDevice] = React.useState(getDevice(selectedResolution));

	React.useEffect(() => {
		setDevice(getDevice(selectedResolution));
	}, [selectedResolution]);

	return device;
};

export default useDevice;
